import { TextButton } from "../../Buttons/TextButton"
import GridIcon from "../../../public/images/icons/video/grid-view.svg";
import ListIcon from "../../../public/images/icons/video/list-view.svg";
import { MediaTypeSelector } from "./MediaTypeSelector";
import cls from 'clsx';
import { SelectDropdown } from "../../Form/SelectDropdown/SelectDropdown";
import { MediaViewType } from "./MediaViewType";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useMediaParams } from "../MediaFeed/useMediaParams";
import SelectIcon from '../../../public/images/icons/select.svg';
import styles from '../../Navigation/Unauthorized/AccountDropdown.module.css';
import { Spinner } from "../../Spinner/Spinner";
import { useContext, useEffect } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { MediaSearchOrder, MediaType } from "@jconradi/tutu-porn-api-client/src/media";

export const DisplayMediaSearchOrder: { [key in MediaSearchOrder]: any} = {
    [MediaSearchOrder.Top]: "mediaSearchOrder.allTimeTop",
    [MediaSearchOrder.MonthlyTop]: "mediaSearchOrder.monthlyTop",
    [MediaSearchOrder.WeeklyTop]: "mediaSearchOrder.weeklyTop",
    [MediaSearchOrder.Trending]: "trending",
    [MediaSearchOrder.Latest]: "mediaSearchOrder.latest",
    [MediaSearchOrder.Oldest]: "mediaSearchOrder.oldest",
}

export const MediaFilter = ({ order, setOrder, type, setType, view, setView }: any) => {
    const { t } = useTranslation('common');
    const router = useRouter();
    const { jwtData } = useContext(AuthContext);
    const { setPage, verified, setVerified, horizontal, setHorizontal, vertical, setVertical, 
        transcoding, setTranscoding, unapproved, setUnapproved } = useMediaParams();

    const filtersSelected = (verified || false) +  (+horizontal || false) +  (+vertical || false);

    const isMod = jwtData?.role === 'moderator';

    return (
        <div className="flex flex-col gap-y-4 mb-4">
            <MediaTypeSelector mediaType={type as MediaType} setMediaType={(type) => {
                setType(type);
                setPage(undefined);
            }} />
            <div className="flex flex-row flex-wrap justify-end gap-y-4">


                <div className="flex flex-row flex-1 -mt-4">
                    <TextButton onClick={() => setView(MediaViewType.Grid)} active={view === MediaViewType.Grid} className="after:content-none bg-base-300" side="left">
                        <GridIcon className="w-[20px] h-[20px]" />
                    </TextButton>
                    <TextButton onClick={() => setView(MediaViewType.List)} active={view === MediaViewType.List} className="after:content-none bg-base-300" side="right">
                        <ListIcon className="w-[20px] h-[20px]" />
                    </TextButton>
                </div>

                <div className="flex flex-col-reverse sm:flex-row items-center">
                    <p className="text-sm sm:text-base mx-2">{t('mediaFilters.label')}</p>
                    <div className={cls('dropdown dropdown-bottom h-[54px]', styles.account_dropdown)}>
                        <label style={{
                            borderRadius: '16px',
                            border: '3px solid #373a41'
                        }} tabIndex={0} 
                        className={cls("btn font-bold m-1 hover:bg-outline normal-case flex flex-row gap-x-4", {
                            ['bg-primary border-purple-900']: filtersSelected > 0,
                            ['bg-base-300']: !filtersSelected
                        })}>{!router.isReady ? <Spinner /> : (!filtersSelected ? '...' : t('mediaFilters.filtersSelected', { count: filtersSelected}))}
                            <SelectIcon className="w-6 h-8 text-white -mr-[14px]" />
                        </label>
                        <ul tabIndex={0} className="dropdown-content menu shadow bg-base-100 rounded-box w-52">
                            <MediaFilterItem id="verified" label={t('mediaFilters.verified')} value={verified} setValue={setVerified} />

                            <MediaFilterItem id="horizontal" label={t('mediaFilters.horizontal')} value={horizontal} setValue={setHorizontal} />

                            <MediaFilterItem id="vertical" label={t('mediaFilters.vertical')} value={vertical} setValue={setVertical} />

                            {isMod && 
                                <>
                                    <MediaFilterItem id="isTranscoding" label={t('mediaFilters.transcoding')} value={transcoding} setValue={setTranscoding} />
                                    
                                    <MediaFilterItem id="unapproved" label={t('mediaFilters.unapproved')} value={unapproved} setValue={setUnapproved} />
                                </>
                            }
                        </ul>
                    </div>
                </div>

                <div className="flex flex-col-reverse sm:flex-row items-center">
                    <p className="text-sm sm:text-base  mx-2">{t('mediaSearchOrder.label')}</p>
                    <SelectDropdown isLoading={!router.isReady} entries={Object.values(DisplayMediaSearchOrder)} value={t(DisplayMediaSearchOrder[order as MediaSearchOrder])}>
                        {Object.entries(MediaSearchOrder).map(([key, value]) => {
                            return (
                                <button key={value} onClick={() => {
                                    setOrder(value);
                                    setPage(undefined);
                                }}>{t(DisplayMediaSearchOrder[value as MediaSearchOrder])}</button>
                            )
                        })}
                    </SelectDropdown>
                </div>
            </div>
        </div>
    )
}

const MediaFilterItem = ({ id, label, setValue, value }: any) => {
    const { setPage } = useMediaParams();

    return (
        <li>
            <label htmlFor={id} className="w-full flex flex-row">
                <input onChange={(e:any) => {
                    setValue(value ? undefined : 1);
                    setPage(undefined);
                }} checked={value == true} id={id} type="checkbox" className={cls("checkbox", {
                    ['checkbox-primary']: value === true
                })} />
                <p className="break-normal whitespace-normal flex-1">
                {label}

                </p>
                </label>
        </li>
    )
}